import { Routes, Route } from 'react-router-dom';
import NotFound from 'views/not-found';
import Sales from 'views/sales';

const SalesRoutes = (): JSX.Element => (
	<Routes>
		<Route element={<Sales />} index />
		<Route element={<NotFound />} path="*" />
	</Routes>
);

export default SalesRoutes;
